import { useState, FormEvent } from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [subDone, setSubDone] = useState(false);

  const handleSub = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const body = new URLSearchParams({ email });
    await fetch("https://readdy.ai/api/form/d7dr017sch5bvrijfm00", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: body.toString(),
    });
    setSubDone(true);
  };

  return (
    <footer className="bg-[#1a1209] text-white">
      {/* Newsletter */}
      <div className="border-b border-white/10 py-14 px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-8">
          <div>
            <h3 className="text-2xl font-bold mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>Stay in the Glam Loop</h3>
            <p className="text-white/50 text-sm">Exclusive tips, promotions, and behind-the-chair updates.</p>
          </div>
          {subDone ? (
            <p className="text-[#C9A96E] font-semibold text-sm tracking-widest uppercase">Thank you for subscribing!</p>
          ) : (
            <form data-readdy-form id="newsletter-form" onSubmit={handleSub} className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">
              <input name="email" required type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Your email address" className="bg-white/5 border border-white/10 rounded-sm px-5 py-3 text-white text-sm placeholder-white/30 focus:outline-none focus:border-[#C9A96E] transition-colors w-full sm:w-72" />
              <button type="submit" className="bg-[#C9A96E] text-white text-sm font-semibold tracking-widest uppercase px-8 py-3 rounded-sm hover:bg-[#b8934f] transition-colors whitespace-nowrap cursor-pointer">Subscribe</button>
            </form>
          )}
        </div>
      </div>

      {/* Main Footer */}
      <div className="py-16 px-6">
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <div className="h-28 w-64 mb-5">
              <img src="https://static.readdy.ai/image/50f4002bde5ecf02750e3107d0496ef3/5e0d07911b61a14370f6177f408224a1.png" alt="VegasGlamHair" className="h-full w-full object-contain object-left" style={{ imageRendering: 'auto' }} />
            </div>
            <p className="text-white/50 text-sm leading-relaxed mb-6">European-trained hair artistry in the heart of Las Vegas. Luxury results. Real expertise.</p>
            <div className="flex gap-4">
              {["ri-instagram-line","ri-facebook-line","ri-tiktok-line","ri-pinterest-line"].map(icon => (
                <a key={icon} href="#" rel="nofollow" className="w-9 h-9 flex items-center justify-center rounded-full border border-white/10 text-white/50 hover:border-[#C9A96E] hover:text-[#C9A96E] transition-colors cursor-pointer">
                  <i className={`${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>
          <div>
            <h4 className="text-xs font-bold tracking-widest uppercase text-white/40 mb-5">Services</h4>
            <ul className="flex flex-col gap-3">
              {["Balayage & Color","Haircuts & Blowouts","Keratin Treatments","Hair Extensions","Bridal Styling"].map(s => (
                <li key={s}><Link to="/services" className="text-white/60 text-sm hover:text-[#C9A96E] transition-colors cursor-pointer">{s}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-xs font-bold tracking-widest uppercase text-white/40 mb-5">Quick Links</h4>
            <ul className="flex flex-col gap-3">
              {[["About Us","/#about"],["Our Team","/team"],["Portfolio","/portfolio"],["Promotions","/promotions"],["Journal","/blog"],["Book Now","/booking"]].map(([label, href]) => (
                <li key={label}><Link to={href} className="text-white/60 text-sm hover:text-[#C9A96E] transition-colors cursor-pointer">{label}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-xs font-bold tracking-widest uppercase text-white/40 mb-5">Visit Us</h4>
            <address className="not-italic flex flex-col gap-3">
              <p className="text-white/60 text-sm leading-relaxed">3750 Las Vegas Blvd S, Suite 210<br />Las Vegas, NV 89109</p>
              <a href="tel:+17025550199" className="text-white/60 text-sm hover:text-[#C9A96E] transition-colors cursor-pointer">+1 (702) 555-0199</a>
              <a href="mailto:hello@vegasglamhair.com" className="text-white/60 text-sm hover:text-[#C9A96E] transition-colors cursor-pointer">hello@vegasglamhair.com</a>
              <div className="text-white/40 text-xs leading-relaxed mt-1">
                <p>Mon–Fri: 9am – 7pm</p>
                <p>Sat: 9am – 6pm</p>
                <p>Sun: 10am – 4pm</p>
              </div>
            </address>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10 py-6 px-6">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/30 text-xs">&copy; 2026 VegasGlamHair.com. All rights reserved.</p>
          <div className="flex gap-6">
            <a href="#" rel="nofollow" className="text-white/30 text-xs hover:text-white/60 transition-colors cursor-pointer">Privacy Policy</a>
            <a href="#" rel="nofollow" className="text-white/30 text-xs hover:text-white/60 transition-colors cursor-pointer">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
